import { cardItems } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          推荐阅读
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.slice(0, 7).map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl overflow-hidden group cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}